import { CMSWrapper as Account } from './Account';
import DocumentBackedPageContent from './DocumentBackedPageContent';
import { CMSWrapper as BlogDetail } from './BlogDetail';
import { CMSWrapper as Breadcrumb } from './Breadcrumb';
import { CMSWrapper as CampaignHeader } from './CampaignHeader';
import { CMSWrapper as CardCarousel } from './CardCarousel';
import { CMSWrapper as ComplexTabList } from './ComplexTabList';
import { CMSWrapper as ContentList } from './ContentList';
import { CMSWrapper as CTA } from './CTA';
import { CMSWrapper as CustomerStory } from './CustomerStory';
import { CMSWrapper as CustomHtmlBlock } from './CustomHtmlBlock';
import { CMSWrapper as Dashboard } from './Dashboard';
import { CMSWrapper as DynamicStats } from './DynamicStats';
import { CMSWrapper as FeaturedContent } from './FeaturedContent';
import { CMSWrapper as FilteredList } from './FilteredList';
import { GlobalFooterContainer } from './GlobalFooterContainer';
import { GlobalHeaderContainer } from './GlobalHeaderContainer';
import { CMSWrapper as Hero } from './Hero';
import { CMSWrapper as ImageGallery } from './ImageGallery';
import { CMSWrapper as MarketoForm } from './MarketoForm';
import { CMSWrapper as News } from './News';
import { CMSWrapper as NewsRibbon } from './NewsRibbon';
import { CMSWrapper as PortalNavigation } from './PortalNavigation';
import { CMSWrapper as PowerApps } from './PowerApps';
import { CMSWrapper as PressCenterResource } from './PressCenterResource';
import { CMSWrapper as PressRelease } from './PressRelease';
import { CMSWrapper as PriceList } from './PriceList';
import { CMSWrapper as RichContent } from './RichContent';
import { CMSWrapper as SDL } from './SDL';
import { CMSWrapper as SearchResult } from './SearchResult';
import { CMSWrapper as SEO } from './SEO';
import { CMSWrapper as SolutionMarketplace } from './SolutionMarketplace';
import { CMSWrapper as StickyPopup } from './StickyPopup';
import { CMSWrapper as SolutionDetail } from './TechPartner/SolutionDetail';
import { CMSWrapper as TechPartnerDetail } from './TechPartner/TechPartnerDetail';
import { CMSWrapper as Video } from './Video';

const components = {
  'Blog Detail Content': BlogDetail,
  'Campaign Header': CampaignHeader,
  'Card Carousel': CardCarousel,
  'Complex Tab List': ComplexTabList,
  'Content List': ContentList,
  'Customer Story Content': CustomerStory,
  'Custom HTML': CustomHtmlBlock,
  'Document Backed Page Content': DocumentBackedPageContent,
  'Dynamic Stats': DynamicStats,
  'Featured Content': FeaturedContent,
  'Filtered List': FilteredList,
  'Image Gallery': ImageGallery,
  'Marketo Form': MarketoForm,
  'News Ribbon': NewsRibbon,
  PowerApps,
  'Portal Navigation': PortalNavigation,
  'Press Center Resources': PressCenterResource,
  'Press Release Detail Content': PressRelease,
  'Primary Navigation': GlobalHeaderContainer,
  'Rich Content': RichContent,
  'Sticky Popup': StickyPopup,
  'Price list': PriceList,
  'Search Results': SearchResult,
  'Technology Partner Profile': TechPartnerDetail,
  'Technology Partner Solution': SolutionDetail,
  'Account Screen Content': Account,
  Dashboard,
  Breadcrumb,
  CTA,
  Footer: GlobalFooterContainer,
  Hero,
  Marketplace: SolutionMarketplace,
  News,
  SDL,
  seo: SEO,
  Video,
};

export default components;
